import styled from '@emotion/styled'

import TemplateHero from '@/components/templates/TemplateHero'
import TemplateHeader from '@/components/templates/TemplateHeader'
import { TemplateButton } from '@/components/templates/TemplateButton'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'

const Layout = styled.section``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  height: 100px;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 16px;
  font-weight: 700;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 3em;
`

Layout.Link = styled.span`
  margin-left: 10px;
  font-weight: 700;
  font-size: 16px;
`

Layout.Hero = styled(TemplateHero)``

Layout.HeroContainer = styled.div`
  display: flex;
  min-height: calc(var(--preview-height) - 100px);
  max-height: calc(var(--preview-height) - 100px);
  width: 100%;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
`

Layout.TitleContainer = styled.div`
  display: flex;
  width: 100%;
  margin: auto 0;
  justify-content: center;
`

Layout.Title = styled.h1`
  font-size: 94px;
  font-weight: 700;
  align-self: center;
  z-index: 5;
  margin-top: 1em;
`

Layout.Button = styled(TemplateButton)`
  padding: 12px 40px;
  border: none;
  margin: 20px 0;
  border-radius: 50px;
  font-weight: 700;
`
export default Layout
